import React from 'react';

import { Divider, Paragraph } from '@zillow/constellation-10';

import type { Section } from '../../../../../shared/models/index';
import { SEPARATE_HEATING_CHARGE } from '../../../../../shared/constants';
import HeaderToggle from '../Utilities/HeaderToggle';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const INITIAL_STATE = {
  [SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED]: true,
};

export default function SeparateHeatingCharge_v3({ section, setSectionValues }: Props): JSX.Element {
  const separateHeatingCharge_isEnabled = section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED);

  function toggleUtility(): void {
    setSectionValues({
      ...INITIAL_STATE,
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(
        SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED,
      ),
    });
  }

  return (
    <>
      <HeaderToggle
        header="Heating costs"
        subheader="Applies to this property"
        switchOn={separateHeatingCharge_isEnabled}
        onSwitchToggle={toggleUtility}
      />
      {separateHeatingCharge_isEnabled && (
        <>
          <Divider css={{ marginTop: 'layout.tighter', marginBottom: 'layout.tighter' }} />
          <Paragraph>
            Under Oregon Law, heating costs that are separate from other utilities may not be charged separately from
            base rent.
          </Paragraph>
        </>
      )}
    </>
  );
}
